import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/job/tenant";

export default {
  async getAvailableCurrency(reservationId) {
    return await axios
      .get(endpoint + `/complete/${reservationId}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async submitCompleteTrip(reservationId, payload) {
    return await axios
      .post(endpoint + `/complete/${reservationId}`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async countAll(period, mode) {
    return await axios
      .get(endpoint + `/count?period=${period}&mode=${mode}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getDetail(reservationId) {
    return await axios
      .get(endpoint + `/detail/${reservationId}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getPreferredProviders(reservationId) {
    return await axios
      .get(endpoint + `/list/provider/${reservationId}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async manualDispatch(request) {
    return await axios
      .post(endpoint + "/provider/dispatch/manual", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async releaseProvider(request) {
    return await axios
      .post(endpoint + "/provider/release", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async abort(request) {
    return await axios
      .post(endpoint + "/abort", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async viewHistoryEvidence(id) {
    return await axios
      .get(endpoint + `/history/attach/${id}`)
      .then(response => {
        return response.data;
      });
  },
  async confirmUnderReview(payload) {
    return await axios
      .post(endpoint + `/confirm`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/job/tenantJob/inquiryTenantJobService.js